import React from "react";
import PdfButton from "./PdfButton";

const PdfPointer = ({data}) => {

  const {label, url, size} = data;

  return (
    <div className="flex justify-between items-center border-b border-gray-400 pb-4 mt-4">
      <div className="pl-4">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={3}
          stroke="currentColor"
          className="size-6 inline-block text-primary"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15.75 19.5 8.25 12l7.5-7.5"
          />
        </svg>
        <span>{label}</span>
      </div>
      <PdfButton url={url} size={size}></PdfButton>
    </div>
  );
};

export default PdfPointer;
